<template>
  <main class="home soporte">
    <header class="header">
      <div class="soporte-header__content column">
        <h6>ContaFácil Soporte</h6>
        <h2>Cómo podemos ayudarte?</h2>
        <div class="field">
          <p class="control has-icons-right">
            <input
              class="input is-medium is-rounded is-hovered"
              type="text"
              list="searchResult"
              placeholder="Tipea aquí..."
              v-model="searchInput"
              @change="changeInput"
            />
            <span class="icon is-right">
              <i class="fas fa-search"></i>
            </span>
          </p>
          <datalist id="searchResult">
            <option
              :value="article.title"
              v-for="article in searchResult"
              :key="`result-article-${article._id}`"
            ></option>
          </datalist>
        </div>
      </div>
    </header>
    <!-- <template v-if="searchInput">
      <section class="section section-search-result">
        <h3>Resultado de Busqueda:</h3>
        <ul class="list-result-articles my-4" v-if="searchResult.length > 0">
          <li
            v-for="article in searchResult"
            :key="`result-article-${article._id}`"
          >
            <a @click.stop="toArticle(article.slug)">{{ article.title }}</a>
          </li>
        </ul>
        <div class="list-result-articles my-4" v-else>
          <h6>No se encontró lo que estabas buscando</h6>
        </div>
      </section>
    </template> -->
    <template>
      <section class="section section-cards is-hidden-touch">
        <h3>Categorías</h3>
        <div class="cards-wrap columns is-mobile is-multiline my-4">
          <div
            class="column is-one-third-desktop"
            v-for="mainModule in mainModulesCards"
            :key="`main-module-${mainModule.slug}`"
          >
            <div
              class="soporte-card"
              @click="
                $router.push({
                  name: 'soporte-list',
                  params: { id: mainModule.slug }
                })
              "
            >
              <div class="soporte-card__head">
                <img
                  :src="
                    `https://panelweb.contafacil.pe/storage/${mainModule.picture.filename}`
                  "
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>{{ mainModule.name }}</h6>
                <p v-html="mainModule.description"></p>
              </div>
            </div>
          </div>
          <!-- <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: 'ventas' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-ventas.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Ventas</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({
                  name: 'soporte-list',
                  params: { id: 'cotizaciones' }
                })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-cotizaciones.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Cotizaciones</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-clientes.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Clientes y proveedores</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-gastos.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Gastos y compras</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-inventario.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Inventario</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-guias.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Guías de remisión</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-auditoria.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Auditoría</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop">
            <div
              class="soporte-card"
              @click="
                $router.push({ name: 'soporte-list', params: { id: '' } })
              "
            >
              <div class="soporte-card__head">
                <img
                  src="../assets/images/icons/soporte/card-reportes.png"
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>Reportes</h6>
                <p class="px-2">
                  Get started here or review billing Compliances & account
                  settings
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </section>
      <section class="section section-cards--mobile is-hidden-desktop">
        <h3>Categorías</h3>
        <div class="categories-wrap" v-if="mainModulesCards.length > 0">
          <VueSlickCarousel v-bind="settings">
            <div
              class="soporte-card"
              @click="
                $router.push({
                  name: 'soporte-list',
                  params: { id: mainModule.slug }
                })
              "
              v-for="mainModule in mainModulesCards"
              :key="`main-module-${mainModule.slug}-mobile`"
            >
              <div class="soporte-card__head">
                <img
                  :src="
                    `https://panelweb.contafacil.pe/storage/${mainModule.picture.filename}`
                  "
                  alt=""
                />
              </div>
              <div class="soporte-card__body">
                <h6>{{ mainModule.name }}</h6>
                <p v-html="mainModule.description"></p>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </section>
    </template>
    <section
      class="section section-more-categories columns is-mobile is-multiline"
    >
      <div class="section-more-categories-wrap columns is-mobile is-multiline">
        <div
          class="column more-categories-content is-full-mobile is-two-thirds-desktop"
        >
          <h3>Más categorías</h3>
          <div class="categories">
            <ul class="columns">
              <div class="column">
                <li
                  class="featured-module-item"
                  v-for="featMod in featuredModuleOne"
                  :key="`feature-module-${featMod.slug}`"
                  @click="featureLink(featMod)"
                >
                  {{ featMod.name }}
                </li>
                <!-- <li>Caja en efectivo</li>
                <li>Configuración</li>
                <li>Planes y pagos</li>
                <li>Cargas masivas</li>
                <li>Facturación electrónica</li>
                <li>Puntos de venta</li> -->
              </div>
              <div class="column">
                <li
                  class="featured-module-item"
                  v-for="featMod in featuredModuleTwo"
                  :key="`feature-module-${featMod.slug}`"
                  @click="featureLink(featMod)"
                >
                  {{ featMod.name }}
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="column card-info-wrap">
          <div class="card-info">
            <h4>
              ¿Te gustaría contactarte <br />
              con nosotros?
            </h4>
            <div class="info">
              <img src="../assets/images/icons/soporte/soporte-email.png" alt />
              <a class="color-primary" href="">Conta1@contafacil.pe</a>
            </div>
            <div class="info">
              <img src="../assets/images/icons/soporte/soporte-phone.png" alt />
              <a class="color-primary" href="">+51 587 985 854</a>
            </div>
            <h6>Soporte</h6>
            <p>Lunes y Martes - Sábado y Domingo</p>
            <p>8am - 5pm</p>
            <p>(Incluyendo Feriados)</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// @ is an alias to /src
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Soporte",
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      isPiPEnabled: false,
      settings: {
        arrows: false,
        dots: true,
        // centerMode: true,
        // centerPadding: "5%",
        // infinite: true,
        // slidesToShow: 1,
        dotsClass: "slick-dots-custom"
      },
      searchInput: null,
      featuredModulePivot: 6
    };
  },
  computed: {
    searchResult() {
      return this.$store.state.searchArticleList;
    },
    mainModulesCards() {
      return this.$store.getters.modulesMainlistGetter;
    },
    featuredModules() {
      return this.$store.getters.modulesFeaturedGetter;
    },
    limit() {
      return this.featuredModulePivot > this.featuredModules.length / 2
        ? this.featuredModulePivot
        : Math.ceil(this.featuredModules.length / 2);
    },
    featuredModuleOne() {
      return this.featuredModules.slice(0, this.limit);
    },
    featuredModuleTwo() {
      return this.featuredModules.slice(this.limit);
    }
  },
  async created() {
    this.$modal.show("loader-root");
    await this.$store.dispatch("getModulesMainlist");
    await this.$store.dispatch("getModulesFeatured");
    this.$modal.hide("loader-root");
  },
  methods: {
    toArticle(slug) {
      console.log(slug);
      this.$router.push({ name: "soporte-article", params: { slug: slug } });
    },
    changeInput(val) {
      let titleResult = val.target.value;
      let result = this.searchResult.find(art => art.title === titleResult);
      if (result) {
        this.toArticle(result.slug);
      }
    },
    featureLink(val) {
      console.log(val);
      if (val.isMain) {
        this.$router.push({ name: "soporte-list", params: { id: val.slug } });
      } else {
        let parent = this.getParent(val.slug);
        if (parent) {
          this.$router.push({
            name: "soporte-list",
            params: { id: parent.slug },
            hash: `#${val.slug}`
          });
        }
      }
    },
    getParent(slugChild) {
      console.log(slugChild);
      console.log(this.$store.getters.modulesGetter);
      return this.$store.getters.modulesGetter
        .filter(mod => mod.submodules.length > 0)
        .find(modu => modu.submodules.find(sub => sub.slug === slugChild));
    }
  },
  watch: {
    searchInput: async function(n, o) {
      console.log(n, o);
      await this.$store.dispatch("searchSupport", n);
    }
  }
};
</script>
<style lang="scss">
.slick-dots-custom {
  position: absolute;
  bottom: 0px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  & li.slick-active button {
    &::before {
      opacity: 0.75;
      color: black;
    }
  }
  & li {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
    & button {
      font-size: 0;
      line-height: 0;
      display: block;
      width: 20px;
      height: 20px;
      padding: 5px;
      cursor: pointer;
      color: transparent;
      border: 0;
      outline: none;
      background: transparent;
      &::before {
        font-family: "slick";
        font-size: 10px;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        content: "•";
        text-align: center;
        opacity: 0.25;
        color: black;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";

.header {
  // background-color: red;
  height: calc(90vh - 75px);
  // max-height: 920px;
  // width: 100%;
  display: flex;
  background-image: url("../assets/images/banners/soporte_mobile.svg");
  background-repeat: no-repeat;
  background-size: contain;
  // background-position: bottom left, top right;
  background-attachment: local;
  background-origin: border-box;

  // margin-left: 0px !important;
  .soporte-header__content {
    background-color: transparent;
    height: 50%;
    margin-top: auto;
    width: 100%;
    padding: 1em;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: center;
    h2 {
      text-align: center;
      font-size: 1.2rem;
      font-weight: bold;
      letter-spacing: 0.075em;
      margin: 1em auto;
    }
    h6 {
      text-align: center;
      font-size: 1rem;
      font-weight: bold;
      letter-spacing: 0.025em;
    }
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
    padding: 3rem 0;
    .button {
      margin: 0 1rem;
    }
  }
  @include tablet() {
    background-image: url("../assets/images/banners/soporte_banner.svg") !important;
    background-size: contain;
    height: calc(50vh - 75px);
    .soporte-header__content {
      margin-top: 0;
      height: 70%;
      h2 {
        font-size: 2rem;
        margin: 0;
        margin-bottom: 1rem;
      }
      h6 {
        font-size: 1.5rem;
      }
      .field {
        width: 55%;
      }
    }
  }
  @media (min-width: 1024px) {
    background-image: url("../assets/images/banners/soporte_person.svg"),
      url("../assets/images/banners/soporte_sun.svg");
    background-size: 18%, 18%;
    background-position: left bottom, right top;
    height: calc(80vh - 100px);
    max-height: none !important;
    display: block;
    // background-size: 15%, 15%;
    .soporte-header__content {
      height: 100%;
      padding: 5em 1em;
      h2 {
        font-size: 2rem;
        margin-bottom: 1rem;
      }
      h6 {
        font-size: 1.5rem;
      }
      .field {
        width: 55%;
      }
    }
  }
  @media (min-width: 1200px) {
    // background-size: 15%, 15%;
    .soporte-header__content {
      h2 {
        font-size: 2rem;
        margin-bottom: 1rem;
      }
      h6 {
        font-size: 1.5rem;
      }
      .field {
        width: 55%;
      }
    }
  }
  @media (min-width: 1400px) {
    // background-size: 23%, 20%;
    height: 80vh !important;
    .soporte-header__content {
      h2 {
        font-size: 3.5rem;
        margin-bottom: 1rem;
      }
      h6 {
        font-size: 1.5rem;
      }
      .field {
        width: 50%;
      }
    }
  }
}
.header-small {
  max-height: 400px;
  @include tablet() {
    max-height: 600px;
  }
}
.section-cards {
  width: 100%;
  padding: 5rem 2rem;
  padding-top: 1rem;
  margin: 0rem auto;
  margin-bottom: 3rem;
  h3 {
    font-weight: bold;
    margin-bottom: 2rem;
  }
  &--mobile {
    margin: 0 0 2em;
    h3 {
      font-size: 1.5em;
      margin: 0em auto 2em;
      font-weight: bold;
    }
  }
  // .row {
  //   margin-bottom: 3rem;
  // }
  @include tablet() {
    h3 {
      font-size: 2rem;
    }
  }
}
.soporte-card {
  border: thin solid #058b87;
  border-radius: 30px;
  // max-width: 250px !important;
  // margin: 4.6px auto;
  height: 300px;
  margin-bottom: 4rem;
  width: 250px !important;
  cursor: pointer;
  &__head {
    background-image: url("../assets/images/icons/soporte/card-bg.png");
    background-repeat: no-repeat;
    background-size: 90px 90px;
    background-position: center;
    height: 60%;
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    img {
      width: 75px;
      height: 75px;
      position: absolute;
      top: 20%;
      left: 25%;
    }
  }
  &__body {
    height: 40%;
    width: 100%;
    h6 {
      font-weight: bold;
      font-size: 1.2rem;
      margin-bottom: 1em;
    }
    p {
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.3;
    }
  }
  @include laptop() {
    margin-bottom: 0px;
    &__body {
      height: 40%;
      width: 100%;
      h6 {
        font-weight: bold;
      }
      p {
        font-weight: 400;
        font-size: 0.9rem;
        margin-top: 10px;
      }
    }
  }
}
.section-more-categories {
  background-color: #eafffe;
  padding: 0;
  padding-top: 1rem;
  width: 100%;
  box-sizing: border-box;
  margin: 0;

  .more-categoires-content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
  h3 {
    text-align: start;
    font-weight: bold;
    font-size: 1.2rem;
    letter-spacing: 0.1em;
    margin: 1em auto;
    width: 80%;
  }
  .categories {
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: flex-start;
    width: 80%;
    margin: 3rem auto;
    .column {
      display: block;
      flex-basis: 0;
      flex-grow: 1;
      flex-shrink: 1;
      padding: 0;
    }
    ul {
      width: 100%;
      text-align: start;
      font-weight: bold;
      font-size: 0.9rem;
      list-style: none; /* Remove default bullets */
      margin-left: 1.5rem;
      margin-top: 1rem;
      .featured-module-item {
        cursor: pointer;
      }
      li {
        margin: 0.8rem 0;
      }
    }

    ul li::before {
      content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
      color: #058b87; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
  }
  @include tablet() {
    .categories {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;
    }
    h3 {
      font-size: 1.8rem;
    }
    ul {
      font-size: 1.2rem;
    }
  }
  @include laptop() {
    margin-bottom: 2rem;
    padding: 5rem 1rem;
    h3 {
      font-size: 2.5rem;
      margin-bottom: 3rem;
      width: 100%;
    }
    .categories {
      width: 100%;
      .column {
        padding: 0.75rem;
      }
      ul {
        font-size: 1.2rem;

        li {
          margin: 1em 0;
        }
      }
    }
  }
}
.card-info-wrap {
  // padding-left: 0 !important;
  // padding-right: 0 !important;
  @media (max-width: 768px) {
    padding: 0;
  }
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-info {
  background-color: #ffffff;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.53);
  z-index: 9;
  width: 100%;
  height: 100%;
  padding: 1rem;
  margin: 0 auto;
  p,
  h4,
  h6 {
    margin: 8px;
    line-height: 1.6;
  }
  h4,
  h6 {
    font-weight: bold;
  }
  h4 {
    font-size: 17px;
  }
  h6 {
    font-size: 1rem;
    margin-top: 3em;
  }
  .info {
    font-weight: bold;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    margin: 8px auto;
    font-size: 15px;
    img {
      height: 15px;
      width: auto;
      margin-right: 10px;
    }
    a {
      text-decoration: underline;
    }
  }
  p {
    font-size: 0.9rem;
    color: #6d6e70;
  }
  @include laptop() {
    width: 300px;
    height: 380px;
    box-shadow: 2px 4px 13px rgba(0, 0, 0, 0.53);
    border-radius: 40px;
    p {
      font-size: 0.8rem;
    }
    h4 {
      margin: 1.5rem auto;
    }
    h6 {
      font-size: 0.9rem;
    }
    .info {
      margin: 1rem auto;
    }
  }
}
.input-search-wrap {
  img {
    left: 20px !important;
  }
}
.cards-wrap {
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
}
.section-more-categories-wrap {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
input::placeholder {
  font-size: 0.9em !important;
  font-weight: bold;
  letter-spacing: 0.05em;
}
.section-search-result {
  h3 {
    font-weight: bold;
  }
}
.list-result-articles {
  // width: 70%;
  max-width: 700px;
  margin: 2em auto;
  li {
    margin: 1rem 0;
    text-align: start;
    a {
      color: $primary;
      &:hover {
        color: $accent;
      }
    }
  }
}
</style>
